import React, { useEffect, useState, useCallback } from 'react';
import { Link } from 'react-router-dom';
import { portalApi } from '../../lib/parceiroApi';
import { formatCurrency, formatDate } from '../../lib/utils';
import ParceiroStatusBadge from '../../components/ParceiroStatusBadge';
import { Input } from '../../components/ui/input';
import { Search, Loader2, AlertCircle } from 'lucide-react';

const FILTROS = [
  { v: 'todas', t: 'Todas' },
  { v: 'abertas', t: 'Abertas' },
  { v: 'agendadas', t: 'Agendadas' },
  { v: 'em_andamento', t: 'Em andamento' },
  { v: 'concluidas', t: 'Concluídas' },
  { v: 'canceladas', t: 'Canceladas' },
];

export default function ParceiroSolicitacoes() {
  const [filtro, setFiltro] = useState('todas');
  const [busca, setBusca] = useState('');
  const [lista, setLista] = useState(null);

  const load = useCallback(() => {
    portalApi.listSolicitacoes(filtro, busca).then((r) => setLista(r.data)).catch(() => setLista([]));
  }, [filtro, busca]);

  useEffect(() => {
    const t = setTimeout(load, busca ? 350 : 0);
    return () => clearTimeout(t);
  }, [load, busca]);

  return (
    <div className="space-y-4" data-testid="parceiro-solicitacoes">
      <h1 className="text-xl font-bold text-[#3D4F5F]">Minhas solicitações</h1>
      <div className="relative">
        <Search size={16} className="absolute left-3 top-3 text-gray-400" />
        <Input className="pl-9" placeholder="Buscar por OS, cliente, imóvel, endereço, data..." value={busca} onChange={(e) => setBusca(e.target.value)} data-testid="busca-solicitacoes" />
      </div>
      <div className="flex gap-2 overflow-x-auto pb-1">
        {FILTROS.map((f) => (
          <button key={f.v} onClick={() => setFiltro(f.v)} data-testid={`filtro-${f.v}`}
            className={`px-3.5 py-1.5 rounded-full text-xs font-semibold whitespace-nowrap border ${filtro === f.v ? 'bg-[#3D4F5F] text-white border-[#3D4F5F]' : 'bg-white text-gray-600 border-gray-300'}`}>
            {f.t}
          </button>
        ))}
      </div>

      {!lista ? (
        <div className="flex justify-center py-16"><Loader2 className="animate-spin text-gray-400" size={26} /></div>
      ) : lista.length === 0 ? (
        <div className="bg-white rounded-xl border border-dashed border-gray-300 p-10 text-center text-sm text-gray-500">Nenhuma solicitação encontrada.</div>
      ) : (
        <div className="space-y-2">
          {lista.map((o) => (
            <Link key={o.id} to={`/parceiro/solicitacoes/${o.id}`} className="block bg-white rounded-xl border border-gray-200 p-3.5 hover:border-[#2B7A3D] transition-colors" data-testid={`solicitacao-item-${o.numero}`}>
              <div className="flex items-start justify-between gap-2">
                <div className="min-w-0">
                  <div className="flex items-center gap-2">
                    <span className="text-sm font-bold text-[#3D4F5F]">#OS-{String(o.numero).padStart(4, '0')}</span>
                    {o.prioridade === 'urgente' && <span className="text-[10px] font-bold text-red-600 bg-red-50 px-1.5 py-0.5 rounded">URGENTE</span>}
                    {o.aprovacao_parceiro === 'aguardando_aprovacao' && (
                      <span className="flex items-center gap-1 text-[10px] font-bold text-amber-700 bg-amber-50 px-1.5 py-0.5 rounded"><AlertCircle size={11} /> APROVAR VALOR</span>
                    )}
                  </div>
                  <div className="text-sm text-gray-700 truncate mt-0.5">{o.servico_nome}</div>
                  <div className="text-xs text-gray-500 truncate">{o.cliente_nome} · {o.imovel_descricao || o.cidade_atendimento} · {formatDate(o.data_agendamento)}</div>
                </div>
                <div className="text-right shrink-0">
                  <ParceiroStatusBadge status={o.status} />
                  {o.valor > 0 && <div className="text-sm font-semibold text-gray-800 mt-1">{formatCurrency(o.valor)}</div>}
                </div>
              </div>
            </Link>
          ))}
        </div>
      )}
    </div>
  );
}
